"use client"

import * as React from "react"
import { Label, Pie, PieChart } from "recharts"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "src/@/components/ui/card"
import {
    ChartContainer,
    ChartLegend,
    ChartLegendContent,
    ChartTooltip,
    ChartTooltipContent,
} from "src/@/components/ui/chart"
import EmptyContentGhost from "src/components/EmptyContentGhost"
import { fShortenNumber } from "src/utils/formatNumber"

const chartConfig = {
    total: {
        label: "total",
    },
    perda: {
        label: "Perda",
        color: "#DACFFB",
      },
      ganho: {
        label: "Ganho",
        color: "#ff5f5f",
      },
}
export function GraficoTotalGanhosPerdas({ chartData }) {

    const totalVisitors = React.useMemo(() => {
        return chartData.reduce((acc, curr) => acc + curr.total, 0)
    }, [])


    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <CardTitle>Valores negociados</CardTitle>
                    <CardDescription>
                       Valores dos negocios ganhos e perdidos
                    </CardDescription>
                </div>

            </CardHeader>
            <CardContent>
                {
                    totalVisitors === 0 ? (
                        <EmptyContentGhost />
                    ) : (
                        <ChartContainer
                            config={chartConfig}
                            className="aspect-square w-full h-[250px]"
                        >
                            <PieChart>
                                <ChartTooltip
                                    cursor={false}
                                    content={<ChartTooltipContent hideLabel />}
                                />
                                                                 <ChartLegend content={<ChartLegendContent nameKey="tipo" />} />

                                <Pie
                                    data={chartData}
                                    dataKey="total"
                                    nameKey="tipo"
                                    innerRadius={60}
                                    strokeWidth={5}
                                    fill={(entry) => {
                                        const config = chartConfig[entry.tipo]
                                        return config ? config.color : "#ccc" // Cor padrão, se não houver configuração
                                    }}
                                >
                                    <Label
                                        content={({ viewBox }) => {
                                            if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                                                return (
                                                    <text
                                                        x={viewBox.cx}
                                                        y={viewBox.cy}
                                                        textAnchor="middle"
                                                        dominantBaseline="middle"
                                                    >
                                                        <tspan
                                                            x={viewBox.cx}
                                                            y={viewBox.cy}
                                                            className="fill-foreground text-lg font-bold"
                                                        >
                                                            R${fShortenNumber(totalVisitors) }
                                                        </tspan>
                                                        <tspan
                                                            x={viewBox.cx}
                                                            y={(viewBox.cy || 0) + 24}
                                                            className="fill-muted-foreground"
                                                        >
                                                            negociados
                                                        </tspan>
                                                    </text>
                                                )
                                            }
                                        }}
                                    />
                                </Pie>
                            </PieChart>
                        </ChartContainer>
                    )
                }

            </CardContent>
        </Card>
    )
}
